import moment from 'moment';
import { Dispatch } from 'redux';
import {
  findMedicalCertificates,
  MedicalCertificateGETData,
} from './../../services/peopleManagement.service';

export const medicalCertificatesActionsTypes = {
  GET_MEDICAL_CERTIFICATES: 'GET_MEDICAL_CERTIFICATES',
  GET_MEDICAL_CERTIFICATES_SUCCESS: 'GET_MEDICAL_CERTIFICATES_SUCCESS',
  GET_MEDICAL_CERTIFICATES_FAILURE: 'GET_MEDICAL_CERTIFICATES_FAILURE',
};

export const getMedicalCertificates = ({
  periodFrom,
  periodUntil,
  reference,
}: MedicalCertificateGETData) => async (dispatch: Dispatch) => {
  try {
    dispatch({
      type: medicalCertificatesActionsTypes.GET_MEDICAL_CERTIFICATES,
    });
    const { data } = await findMedicalCertificates({
      reference,
      periodFrom: moment(periodFrom, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      periodUntil: moment(periodUntil, 'DD/MM/YYYY').format('YYYY-MM-DD'),
    });

    dispatch({
      type: medicalCertificatesActionsTypes.GET_MEDICAL_CERTIFICATES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: medicalCertificatesActionsTypes.GET_MEDICAL_CERTIFICATES_FAILURE,
    });
  }
};
